window.dataLayer = window.dataLayer || [];

function pushScreenViewEvent() {
  const lpTrackingElm = document.querySelector('.lp-tracking');
  if (!lpTrackingElm) return;

  const currentQueryString = window.location.search;
  const currentUrlParams = new URLSearchParams(currentQueryString);
  const utmMedium = currentUrlParams.get('utm_medium');
  const utmSource = currentUrlParams.get('utm_source');
  const locale = document.querySelector('html').getAttribute('lang');
  const apiParams = {
    screen: lpTrackingElm.dataset.gtmScreen,
    universe: lpTrackingElm.dataset.gtmUniverse,
    utm_medium: utmMedium,
    utm_source: utmSource,
  };
  const apiCompactParams = Object.fromEntries(
    // eslint-disable-next-line no-unused-vars
    Object.entries(apiParams).filter(([, value]) => value != null),
  );
  const apiQueryString = new URLSearchParams(apiCompactParams).toString();
  const apiUrl = `${window.location.origin}/api/v1/gtm_event_info.json?${apiQueryString}`;

  fetch(apiUrl, {
    headers: {
      'Accept-Language': locale,
    },
  }).then((response) => response.json())
    .then((data) => {
      window.dataLayer.push(data);
      window.dataLayer.push(data.eventProperties);
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error:', error);
    });
}

// Intercept dataLayer.push to detect first-time cookie consent
// Cookiebot signals consent via GTM dataLayer, not window events
// Guard: prevent re-interception on Turbo navigations
if (!window.dataLayerPushIntercepted) {
  const originalPush = window.dataLayer.push;
  if (typeof originalPush === 'function') {
    window.dataLayerPushIntercepted = true;
    window.dataLayer.push = function dataLayerPushInterceptor(obj) {
      const result = originalPush.call(window.dataLayer, obj);
      // Cookiebot object location varies by integration: standalone (window.Cookiebot) vs CookieControl wrapper
      // In CookieControl integration, Cookiebot IS the Cookie instance (with .changed property)
      // CookieControl.Cookie is just the constructor, not the state
      const cookiebotState = window.Cookiebot;
      if (obj.event === 'cookie_consent_update' && cookiebotState?.changed === true) {
        pushScreenViewEvent();
      }
      return result;
    };
  }
}

document.addEventListener('DOMContentLoaded', pushScreenViewEvent);
